import * as AccordionPrimitive from '@radix-ui/react-accordion';
import { ChevronDownIcon } from 'lucide-react';
import * as React from 'react';

import { cn } from '@/utils';

function Accordion({ ...props }: React.ComponentProps<typeof AccordionPrimitive.Root>) {
  return <AccordionPrimitive.Root data-slot='accordion' {...props} />;
}

function AccordionItem({ ...props }: React.ComponentProps<typeof AccordionPrimitive.Item>) {
  return <AccordionPrimitive.Item data-slot='accordion-item' {...props} />;
}

function AccordionTrigger({
  className,
  children,
  hideChevron,
  chevronClassName,
  ...props
}: React.ComponentProps<typeof AccordionPrimitive.Trigger> & { hideChevron?: boolean; chevronClassName?: string }) {
  return (
    <AccordionPrimitive.Header className='flex' asChild>
      <div>
        <AccordionPrimitive.Trigger
          data-slot='accordion-trigger'
          className={cn(
            'flex flex-1 items-start justify-between gap-4 rounded-md py-4 text-left transition-all outline-none focus-visible:ring-[3px] disabled:pointer-events-none disabled:opacity-50 [&[data-state=open]>svg]:rotate-180',
            className,
          )}
          {...props}
        >
          <>
            {children}
            {!hideChevron && (
              <ChevronDownIcon
                className={cn(
                  'text-text-default-secondary pointer-events-none size-6 shrink-0 translate-y-0.5 transition-transform duration-200',
                  chevronClassName,
                )}
              />
            )}
          </>
        </AccordionPrimitive.Trigger>
      </div>
    </AccordionPrimitive.Header>
  );
}

function AccordionContent({ className, children, ...props }: React.ComponentProps<typeof AccordionPrimitive.Content>) {
  return (
    <AccordionPrimitive.Content
      data-slot='accordion-content'
      className='data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down overflow-hidden'
      {...props}
    >
      <div className={cn('pt-0 pb-4', className)}>{children}</div>
    </AccordionPrimitive.Content>
  );
}

export { Accordion, AccordionContent, AccordionItem, AccordionTrigger };
